import React from 'react';
import MIcon from './MIcon';

const SLA_MINUTES = { critical: 15, high: 60, medium: 240, low: 480 };

export default function SLABadge({ ticket, showTime = true }) {
  const slaMin   = SLA_MINUTES[ticket.priority] || 240;
  const resolved = ['resolved','forwarded','scheduled'].includes(ticket.status);

  if (resolved) {
    return (
      <span style={{display:'inline-flex',alignItems:'center',gap:4,height:20,padding:'0 8px',
        borderRadius:20,background:'#E8F5E9',color:'#1E8E3E',
        fontSize:11,fontWeight:600,whiteSpace:'nowrap',flexShrink:0}}>
        <MIcon name="check_circle" size={12} fill={0} weight={500} color="#1E8E3E"/>
        SLA ok
      </span>
    );
  }

  const raw        = String(ticket.created_at || '').replace(' ', 'T');
  const createdAt  = raw.endsWith('Z') ? raw : raw + 'Z';
  const elapsedMin = (Date.now() - new Date(createdAt)) / 60000;
  const pct        = Math.min(100, Math.round((elapsedMin / slaMin) * 100));
  const over       = pct >= 100;
  const warn       = pct >= 70;

  const color = over ? '#D93025' : warn ? '#E37400' : '#1E8E3E';
  const bg    = over ? '#FFEBEE' : warn ? '#FFF3E0' : '#E8F5E9';
  const icon  = over ? 'cancel'  : warn ? 'warning'  : 'schedule';

  const remaining = slaMin - elapsedMin;
  let timeLabel = '';
  if (showTime) {
    if (over) {
      const overMin = Math.round(elapsedMin - slaMin);
      timeLabel = overMin < 60 ? `+${overMin}m` : `+${Math.round(overMin/60)}h`;
    } else {
      timeLabel = remaining < 60 ? `${Math.round(remaining)}m` : `${Math.round(remaining/60)}h`;
    }
  }

  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:4,height:20,padding:'0 8px',
      borderRadius:20,background:bg,color,
      fontSize:11,fontWeight:600,whiteSpace:'nowrap',flexShrink:0}}>
      <MIcon name={icon} size={12} fill={0} weight={500} color={color}/>
      {showTime ? timeLabel : `${pct}%`}
    </span>
  );
}
